import React, { useEffect, useState, useRef } from 'react';
import { Link, useLocation, useHistory  } from 'react-router-dom';
import '../App.css';
import testJson from '.././test/testJson/setting_doorlock_test.json';
import testJson0 from '.././test/testJson/setting_doorlock_test0.json';
import Amplify, {Auth} from 'aws-amplify';
import API_GATEWAY from "./hostname";
import loadimg from "../images/loading.gif";

const getIdToken = () =>{
    return new Promise((resolve, reject) => {
        try{
            Auth.currentSession().then((data) => {
                return resolve(data.getIdToken().getJwtToken());
              });
        }
        catch(e){
            console.log('Not signed in');
            return reject('ID取得失敗')
        }  
    })
}
const _sleep = (ms) => new Promise((resolve) => setTimeout(resolve, ms));
async function getControlResults(token, control_id){
    // すぐに状態取得しないように1秒待つ
    var count = 0;
    var controlResult = "";
    var isSuccess = false;
    while(count < 10){
        await _sleep(1000)
        const statusUrl = API_GATEWAY + "/console/v1/devices/control-results/"+ control_id;
        const resultHeaders = {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'Authorization':token
        };
        const resultMethod = "GET"
        await fetch(statusUrl,{method:resultMethod, headers:resultHeaders, mode:"cors"})
        .then((res)=> res.json())
        .then(data => {
            if(data["status"] == "success"){
                controlResult = data["status"];
                isSuccess = true;
            }else{
                controlResult = data["status"];
            }
        },[])
        .catch(err => {
            controlResult = err;
            })
        if(isSuccess){
            return controlResult;
        }
        count++;
    }
    
    return controlResult;
    
}

const doorlockAllUpdate = () =>{

    // (async () => {
    //     const p1 = someAsyncFunc1();
    //     const p2 = someAsyncFunc2();
    //     const p3 = someAsyncFunc3();
    //     const results = await Promise.all([p1, p2, p3]);
    // })();
    return new Promise((resolve, reject) => {
        try{
            getIdToken()
            .then(result => {
                return resolve();
            }).catch(error => {
                console.error("IDトークン取得失敗")
            })
            
        }
        catch(e){
            console.log('ドアロックア情報更新失敗');
            return reject('ドアロックア情報更新失敗')
        }  
    })
}

function Setting_doorlock() {
    const [admFlag, setAdmFlag] = useState(false);
    const [lockName, setLockName] = useState('');
    const [hotelName, setHotelName] = useState('');
    const history = useHistory();

    const isFirstRender = useRef(false)
    const isFirstRenderOpen = useRef(false)
    const isFirstRenderClose = useRef(false)
    const isFirstRenderAutoOn = useRef(false)
    const isFirstRenderAutoOff = useRef(false)
    const isFirstRenderPinSend = useRef(false)
    const isFirstRenderPinDelete = useRef(false)
    const isFirstRenderCardSend = useRef(false)
    const isFirstRenderCardDelete = useRef(false)
    const isFirstRenderRegist = useRef(false)
    const isFirstRenderDebugbattery = useRef(false)
    const isFirstRenderDebuglock = useRef(false)
    const isFirstRenderDebugrssi = useRef(false)
    const isFirstRenderDebugfw = useRef(false)
    const location = useLocation();
    // const [lockInfo, setLockInfo] = useState(testJson0);
    const [closeInfo, setCloseInfo] = useState(0);
    const [openInfo, setOpenInfo] = useState(0);
    const [autoOnInfo, setAutoOnInfo] = useState(0);
    const [autoOffInfo, setAutoOffInfo] = useState(0);
    const [pinSend, setPinSend] = useState(0);
    const [pinDelete, setPinDelete] = useState(0);
    const [cardSend, setCardSend] = useState(0);
    const [cardDelete, setCardDelete] = useState(0);
    const [registSend, setRegistSend] = useState(0);
    const [update, setUpdate] = useState(0);
    const [debug_updatebattery, setDebugUpdatebattery] = useState(0);
    const [debug_updatelock, setDebugUpdatelock] = useState(0);
    const [debug_updaterssi, setDebugUpdaterssi] = useState(0);
    const [loading, setLoading] = useState(true);

    // 表示情報・送信情報
    const [dateTime, setDateTime] = useState('')
    const [serialNumber, setSerialNumber] = useState('')
    const [connectionGW, setConnectionGW] = useState('')
    const [floor, setFloor] = useState('')
    const [placeName, setPlaceName] = useState('')
    const [oldPlaceName, setOldPlaceName] = useState('')
    const [pinCode, setPinCode] = useState('')
    const [cardCode, setCardCode] = useState('')
    const [battery, setBattery] = useState('')
    const [batteryTime, setBatteryTime] = useState('')
    const [error, setError] = useState('')
    const [errorTime, setErrorTime] = useState('')
    const [lockStatus, setLockStatus] = useState('')
    const [lockStatusTime, setLockStatusTime] = useState('')
    const [doorStatus, setDoorStatus] = useState('')
    const [doorStatusTime, setDoorStatusTime] = useState('')
    const [autoLockStatus, setAutoLockStatus] = useState('')
    const [autoLockStatusTime, setAutoLockStatusTime] = useState('')
    const [rssi, setRssi] = useState('')
    const [rssiTime, setRssiTime] = useState('')
    const [fw_ver, setFw_ver] = useState('')
    const [accessGroup, setAccessGroup] = useState('')
    const [accessGroupLink, setAccessGroupLink] = useState('')
    const [accessGroupLink_card, setAccessGroupLink_card] = useState('')

    // ドアロック状態を画面にセット
    const setDoorlockState = (token) =>{
        console.log("鍵更新開始")
        return new Promise((resolve, reject) => {
            try{
                const updateMethod = "GET";
                const updateHeaders = {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                    'Authorization':token
                };
                const setStatusUrl = API_GATEWAY + "/console/v1/devices/locks/" + location.state.lockID;
                // ドアロック状態を更新
                fetch(setStatusUrl,
                {method:updateMethod, headers:updateHeaders, mode:"cors"})
                .then((res)=> res.json())
                    .then(data => {
                        console.log("鍵状態取得のfetch実行完了")
                        var isError = false;
                        // シリアルナンバー
                        if("serial_number" in data){
                            setSerialNumber(data.serial_number)
                        }
                        else{
                            isError = true;
                            console.log("鍵情報取得失敗：シリアルナンバー")
                        }
                        // 接続ゲートウェイ
                        if("gw_serial_number" in data){
                            setConnectionGW(data.gw_serial_number)
                        }
                        else{
                            isError = true;
                            console.log("鍵情報取得失敗：接続ゲートウェイ")
                        }
                        // 設置フロア
                        if("floor" in data){
                            setFloor(data.floor)
                        }
                        else{
                            isError = true;
                            console.log("鍵情報取得失敗：設置フロア")
                        }
                        // 設置部屋番号
                        if("name" in data){
                            setPlaceName(data.name)
                            setOldPlaceName(data.name)
                        }
                        else{
                            isError = true;
                            console.log("鍵情報取得失敗：設置部屋番号")
                        }
                        // 状態表示
                        if("lock" in data){
                            if("status" in data.lock){
                                if(data.lock.status == "lock"){
                                    setLockStatus("施錠")
                                }
                                else if(data.lock.status == "unlock"){
                                    setLockStatus("解錠")
                                }
                                else{
                                    setLockStatus(data.lock.status)
                                }
                            }
                            else{
                                isError = true;
                                console.log("鍵情報取得失敗：状態表示")
                            }
                            if("door" in data.lock){
                                if(data.lock.door == "open"){
                                    setDoorStatus("開")
                                }
                                else if(data.lock.door == "close"){
                                    setDoorStatus("閉")
                                }
                                else{
                                    setDoorStatus(data.lock.door)
                                }
                            }
                            else{
                                isError = true;
                                console.log("鍵情報取得失敗：状態表示")
                            }
                            if("time" in data.lock){
                                setLockStatusTime(data.lock.time.slice(0, 19).replace('T', ' ').replace(/-/g, '/'))
                                setDoorStatusTime(data.lock.time.slice(0, 19).replace('T', ' ').replace(/-/g, '/'))
                            }
                            else{
                                isError = true;
                                console.log("鍵情報取得失敗：状態表示")
                            }
                        }
                        else{
                            isError = true;
                            console.log("鍵情報取得失敗：状態表示")
                        }
                        // オートロック
                        if("auto_lock" in data){
                            if("status" in data.lock){
                                if(data.auto_lock.status == "enable"){
                                    setAutoLockStatus("ON")
                                }
                                else if(data.auto_lock.status == "disable"){
                                    setAutoLockStatus("OFF")
                                }
                                else{
                                    setAutoLockStatus(data.auto_lock.status)
                                }
                            }
                            else{
                                isError = true;
                                console.log("鍵情報取得失敗：オートロック表示")
                            }
                            if("time" in data.lock){
                                setAutoLockStatusTime(data.auto_lock.time.slice(0, 19).replace('T', ' ').replace(/-/g, '/'))
                            }
                            else{
                                isError = true;
                                console.log("鍵情報取得失敗：オートロック表示")
                            }
                        }
                        else{
                            isError = true;
                            console.log("鍵情報取得失敗：オートロック表示")
                        }
                        // 電池残量
                        if("battery" in data){
                            if("value" in data.battery){
                                setBattery(data.battery.value + "％")
                            }
                            else{
                                isError = true;
                                console.log("鍵情報取得失敗：電池残量")
                            }
                            if("time" in data.battery){
                                setBatteryTime(data.battery.time.slice(0, 19).replace('T', ' ').replace(/-/g, '/'))
                            }
                            else{
                                isError = true;
                                console.log("鍵情報取得失敗：電池残量")
                            }
                        }
                        else{
                            isError = true;
                            console.log("鍵情報取得失敗：電池残量")
                        }
                        // 異常通知
                        if("error" in data){
                            if("event" in data.error){
                                if(data.error.event == "low_battery"){
                                    setError("電池残量（少）")
                                }
                                else if(data.error.event == "low_battery_critical"){
                                    setError("電池残量（致命）")
                                }
                                else if(data.error.event == "deadbolt_jammed"){
                                    setError("デッドボルト詰まり")
                                }
                                else if(data.error.event == "tamper"){
                                    setError("こじ開け")
                                }
                                else if(data.error.event == "3min_lock"){
                                    setError("3分ロック")
                                }
                                else{
                                    setError(data.error.event)
                                }
                            }
                            else{
                                isError = true;
                                console.log("鍵情報取得失敗：異常通知")
                            }
                            if("time" in data.error){
                                setErrorTime(data.error.time.slice(0, 19).replace('T', ' ').replace(/-/g, '/'))
                            }
                            else{
                                isError = true;
                                console.log("鍵情報取得失敗：異常通知時刻")
                            }
                        }
                        else{
                            isError = true;
                            console.log("鍵情報取得失敗：異常通知")
                        }
                        // RSSI
                        if("rssi" in data){
                            if("value" in data.rssi){
                                setRssi(data.rssi.value)
                            }
                            else{
                                isError = true;
                                console.log("鍵情報取得失敗：RSSI")
                            }
                            if("time" in data.rssi){
                                setRssiTime(data.rssi.time.slice(0, 19).replace('T', ' ').replace(/-/g, '/'))
                            }
                            else{
                                isError = true;
                                console.log("鍵情報取得失敗：RSSI")
                            }
                        }
                        else{
                            isError = true;
                            console.log("鍵情報取得失敗：RSSI")
                        }
                        // fw
                        if("fw_ver" in data){
                            setFw_ver(data.fw_ver);
                        }
                        else{
                            isError = true;
                            console.log("鍵情報取得失敗：FW_ver")
                        }
                        // if(isError){
                        //     alert("取得できなかった鍵情報があります")
                        // }
                        // else{
                        //     return resolve("データセット完了");
                        // }

                        // loading終了
                        setLoading(false)
                        return resolve("データセット完了");
                    },[])
                    .catch(err => {
                    console.log("鍵情報取得失敗")
                    setLoading(false)
                    // alert("鍵情報の取得に失敗しました")
                })
            }
            catch(e){
                return reject('施錠状態更新失敗')
            }  
        })
    }

    const lockUpdate = (token) =>{
        console.log("鍵更新開始")
        return new Promise((resolve, reject) => {
            try{
                const updateMethod = "PUT";
                const updateObj = {
                    "command": "lock",
                };
                const updateBody = JSON.stringify(updateObj);
                const updateHeaders = {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                    'Authorization':token
                };
                const updateUrl = API_GATEWAY + "/console/v1/devices/locks/" + location.state.lockID + "/update"
                // ドアロック状態を更新
                fetch(updateUrl,
                {method:updateMethod, headers:updateHeaders,body:updateBody, mode:"cors"})
                .then((res)=> res.json())
                    .then(data => {
                        console.log("鍵更新のfetch実行完了")
                        return resolve(data);
                    },[])
                    .catch(err => {
                    alert("鍵情報の更新に失敗しました")
                })
            }
            catch(e){
                console.log('Not signed in');
                return reject('施錠状態更新失敗')
            }  
        })
    }
    const batteryUpdate = (token) =>{
        return new Promise((resolve, reject) => {
            try{
                const updateMethod = "PUT";
                const updateObj = {
                    "command": "battery",
                };
                const updateBody = JSON.stringify(updateObj);
                const updateHeaders = {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                    'Authorization':token
                };
                const updateUrl = API_GATEWAY + "/console/v1/devices/locks/" + location.state.lockID + "/update"
                // バッテリー状態を更新
                fetch(updateUrl,
                {method:updateMethod, headers:updateHeaders,body:updateBody, mode:"cors"})
                .then((res)=> res.json())
                    .then(data => {
                        console.log("バッテリー更新のfetch実行完了")
                        return resolve(data);
                    },[])
                    .catch(err => {
                    console.log("バッテリー更新のfetch失敗")
                    alert("バッテリーの更新に失敗しました")
                })
            }
            catch(e){
                console.log('Not signed in');
                return reject('バッテリー更新失敗')
            }  
        })
    }
    const rssiUpdate = (token) =>{
        return new Promise((resolve, reject) => {
            try{
                const updateMethod = "PUT";
                const updateObj = {
                    "command": "rssi",
                };
                const updateBody = JSON.stringify(updateObj);
                const updateHeaders = {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                    'Authorization':token
                };
                const updateUrl = API_GATEWAY + "/console/v1/devices/locks/" + location.state.lockID + "/update"
                // rssi状態を更新
                fetch(updateUrl,
                {method:updateMethod, headers:updateHeaders,body:updateBody, mode:"cors"})
                .then((res)=> res.json())
                    .then(data => {
                        console.log("rssi更新のfetch実行完了")
                        return resolve(data);
                    },[])
                    .catch(err => {
                    console.log("rssi更新のfetch失敗")
                    alert("rssiの更新に失敗しました")
                })
            }
            catch(e){
                console.log('Not signed in');
                return reject('rssi更新失敗')
            }  
        })
    }

    const fwUpdate = (token) =>{
        return new Promise((resolve, reject) => {
            try{
                const updateMethod = "PUT";
                const updateObj = {
                    "command": "fw",
                };
                const updateBody = JSON.stringify(updateObj);
                const updateHeaders = {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                    'Authorization':token
                };
                const updateUrl = API_GATEWAY + "/console/v1/devices/locks/" + location.state.lockID + "/update"
                // ドアロック状態を更新
                fetch(updateUrl,
                {method:updateMethod, headers:updateHeaders,body:updateBody, mode:"cors"})
                .then((res)=> res.json())
                    .then(data => {
                        console.log("fw更新のfetch実行完了")
                        return resolve(data);
                    },[])
                    .catch(err => {
                    alert("FWの更新に失敗しました")
                })
            }
            catch(e){
                console.log('Not signed in');
                return reject('fw更新失敗')
            }  
        })
    }

    function setAccessGroupLinkFunc(){
        var aglist = [];
        var card_aglist = [];
        // アクセスグループがあれば、アクセスグループを選択するプルダウンを表示。なければ何も表示しない
        if(location.state.access_groups){
            if(0 < location.state.access_groups.length){
                for(var i in location.state.access_groups){
                    aglist.push(
                    <li class="li_hotels">
                        　<input class="select_access_group" id={location.state.access_groups[i].access_group_id} type="checkbox" /> {location.state.access_groups[i].name}
                    </li>
                    )
                    card_aglist.push(
                        <li class="li_hotels">
                            　<input class="select_card_access_group" id={location.state.access_groups[i].access_group_id} type="checkbox" /> {location.state.access_groups[i].name}
                        </li>
                    )
                }
            }
            setAccessGroupLink(
                <tr>
                    <td class="table_border_updown_thtd_left"> 
                        アクセスグループ
                    </td>
                    <td class="table_border_down_thtd_right" colspan="3">
                            {aglist}
                    </td>
                </tr>
            )
            setAccessGroupLink_card(
                <tr>
                    <td class="table_border_updown_thtd_left"> 
                        アクセスグループ
                    </td>
                    <td class="table_border_down_thtd_right" colspan="3">
                        {card_aglist}
                    </td>
                </tr>
            )
        }
    }

    useEffect(() => {
        isFirstRender.current = true
        isFirstRenderOpen.current = true
        isFirstRenderClose.current = true
        isFirstRenderAutoOn.current = true
        isFirstRenderAutoOff.current = true
        isFirstRenderPinSend.current = true
        isFirstRenderPinDelete.current = true
        isFirstRenderCardSend.current = true
        isFirstRenderCardDelete.current = true
        isFirstRenderDebugbattery.current = true
        isFirstRenderDebuglock.current = true
        isFirstRenderDebugrssi.current = true
        isFirstRenderDebugfw.current = true
        isFirstRenderRegist.current = true
        isAdmin();

        if(location.state){
            setLockName(location.state.lockName);
            setAccessGroupLinkFunc();
            setHotelName(location.state.hotelName);
        }
        else{
            history.push({
                pathname: "/",
            });
        }

        getIdToken()
        .then(result => {
            setDoorlockState(result)
        }).catch(error => {
            console.error("更新時IDトークン取得失敗")
        })
        
    },[])


    const pinCodeHandleChange = (e) => {
        setPinCode(() => e.target.value)
    }
    const cardCodeHandleChange = (e) => {
        setCardCode(() => e.target.value)
    }
   
    const registHandleChange = (e) => {
        setPlaceName(() => e.target.value)
    }

    // 遷移時に呼ばれ、更新を押すたびに呼ばれる
    // useEffect(()=>{
    //     getIdToken()
    //     .then(result => {

    //         // 一つだけ呼ぶ
    //         // rssiUpdate(result)
    //         // .then(result => {
    //         // }).catch(error => {
    //         //     console.error("施錠状態アップデート失敗")
    //         // }
    //         // )

    //         // まとめて呼ぶ（何故かログを沢山入れると通り、入れないとエラーになる？）
    //         (async () => {
    //             const p1 = lockUpdate(result);
    //             const p2 = batteryUpdate(result);
    //             const p3 = rssiUpdate(result);
    //             const p4 = fwUpdate(result);
    //             const results = await Promise.all([p1]);
    //             })();




    //     //     const method = "GET";
    //     //     const headers = {
    //     //         'Accept': 'application/json',
    //     //         'Content-Type': 'application/json',
    //     //         'Authorization':result
    //     //     };
    //     //     // 結合
    //     //     const dataGetUrl = "https://dev-api.iot.leadsecurity.co.jp/console/v1/devices/locks/" + location.state.lockID
    //     //     // 検証
    //     //     // const dataGetUrl = "https://st-api.iot.leadsecurity.co.jp/console/v1/devices/locks/" + location.state.lockID
    //     //     fetch(dataGetUrl,
    //     //     {method:method, headers:headers, mode:"cors"})
    //     //     .then((res)=> res.json())
    //     //         .then(data => {
    //     //             setLockInfo(data)
    //     //         },[])
    //     //         .catch(err => {
    //     //         })
    //     }).catch(error => {
    //         console.error("更新時IDトークン取得失敗")
    //     }
    //     )
    // },[update])

    // 鍵状態更新を押すたびに呼ばれる
    useEffect(()=>{
        if(isFirstRenderDebuglock.current){
            isFirstRenderDebuglock.current = false;
        }else{
            setLoading(true)
            getIdToken()
            .then(result => {
                const token = result;
                lockUpdate(token)
                .then(data => {

                    // 制御結果取得
                    getControlResults(token, data["control_id"])
                    .then(controlResult => {
                        if(controlResult == "success"){
                            console.log("施錠状態アップデート成功")
                            const method = "GET";
                            const headers = {
                                'Accept': 'application/json',
                                'Content-Type': 'application/json',
                                'Authorization':result
                            };
                            const statusUrl = API_GATEWAY + "/console/v1/devices/control-results/"+data["control_id"];
                            fetch(statusUrl,
                            {method:method, headers:headers, mode:"cors"})
                            .then((res)=> res.json())
                                .then(data => {
                                    console.log("鍵の施錠情報が更新されました")
                                    // alert("鍵の施錠情報が更新されました")
                                    // 画面に反映
                                    setDoorlockState(token)
                                },[])
                                .catch(err => {
                                console.log("情報取得のfetch失敗")
                                alert("鍵の施錠状態の更新に失敗しました")
                                })
                        }else{
                            console.error("結果取得失敗"+controlResult)
                            alert("更新に失敗しました。")
                        }
                    },[])

                }).catch(error => {
                    console.error("施錠状態アップデート失敗："+error)
                }
                )
            }).catch(error => {
                console.error("更新時IDトークン取得失敗："+error)
            }
            )
        }
    },[debug_updatelock])

    // 電池残量態更新を押すたびに呼ばれる
    useEffect(()=>{
        if(isFirstRenderDebugbattery.current){
            isFirstRenderDebugbattery.current = false;
        }else{
            setLoading(true)
            getIdToken()
            .then(result => {
                const token = result;
                batteryUpdate(result)
                .then(data => {
                    // 制御結果取得
                    getControlResults(token, data["control_id"])
                    .then(controlResult => {
                        if(controlResult == "success"){
                            console.log("電池状態アップデート成功")
                            const method = "GET";
                            const headers = {
                                'Accept': 'application/json',
                                'Content-Type': 'application/json',
                                'Authorization':result
                            };
                            const statusUrl = API_GATEWAY + "/console/v1/devices/control-results/"+data["control_id"];
                            fetch(statusUrl,
                            {method:method, headers:headers, mode:"cors"})
                            .then((res)=> res.json())
                                .then(data => {
                                    console.log("鍵の電池情報が更新されました")
                                    // alert("鍵の電池情報が更新されました")
                                    // 画面に反映
                                    setDoorlockState(token)
                                },[])
                                .catch(err => {
                                console.log("情報取得のfetch失敗")
                                alert("鍵の電池情報取得に失敗しました")
                                })
                        }else{
                            console.error("結果取得失敗"+controlResult)
                            alert("更新に失敗しました。")
                        }
                    },[])


                }).catch(error => {
                    console.error("電池状態アップデート失敗")
                }
                )
            }).catch(error => {
                console.error("更新時IDトークン取得失敗")
            }
            )
        }

    },[debug_updatebattery])

    // rssi態更新を押すたびに呼ばれる
    useEffect(()=>{
        if(isFirstRenderDebugrssi.current){
            isFirstRenderDebugrssi.current = false;
        }else{
            setLoading(true)
            getIdToken()
            .then(result => {
                const token = result;
                rssiUpdate(result)
                .then(data => {

                    // 制御結果取得
                    getControlResults(token, data["control_id"])
                    .then(controlResult => {
                        if(controlResult == "success"){
                            console.log("rssiアップデート成功")
                            const method = "GET";
                            const headers = {
                                'Accept': 'application/json',
                                'Content-Type': 'application/json',
                                'Authorization':result
                            };
                            const statusUrl = API_GATEWAY + "/console/v1/devices/control-results/"+data["control_id"];
                            fetch(statusUrl,
                            {method:method, headers:headers, mode:"cors"})
                            .then((res)=> res.json())
                                .then(data => {
                                    console.log("鍵のrssi情報が更新されました")
                                    // alert("鍵のrssi情報が更新されました")
                                    // 画面に反映
                                    setDoorlockState(token)
                                },[])
                                .catch(err => {
                                console.log("情報取得のfetch失敗")
                                alert("鍵のrssi情報取得に失敗しました")
                                })
                        }else{
                            console.error("結果取得失敗"+controlResult)
                            alert("更新に失敗しました。")
                        }
                    },[])

                }).catch(error => {
                    console.error("rssi状態アップデート失敗")
                }
                )
            }).catch(error => {
                console.error("更新時IDトークン取得失敗")
            }
            )
        }

    },[debug_updaterssi])

    // 解錠制御を押すたびに呼ばれる
    useEffect(()=>{
        if(isFirstRenderOpen.current){
            isFirstRenderOpen.current = false;
        }
        else{
            if (!window.confirm("解錠します")){
                return;
            }
            getIdToken()
            .then(result => {
                var token = result;
                const obj = {
                    "command": "lock",
                    "parameter": "unlock"
                };
                const method = "PUT";
                const body = JSON.stringify(obj);
                const headers = {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                    'Authorization':token
                  };
                fetch(API_GATEWAY + '/console/v1/devices/locks/' + location.state.lockID,
                {method:method, headers:headers, body:body, mode:"cors"})
                .then((res)=> res.json())
                    .then(data => {
                        console.log("解錠のfetch実行完了")
                        // 制御結果取得
                        getControlResults(token, data["control_id"])
                        .then(controlResult => {
                            if(controlResult == "success"){
                                alert("解錠に成功しました。")
                                setDebugUpdatelock(debug_updatelock+1)
                            }else{
                                console.error("結果取得失敗"+controlResult)
                                alert("解錠に失敗しました。")
                            }
                        },[])

                    },[])
                    .catch(err => {
                        console.log("解錠のfetch失敗")
                        alert("解錠に失敗しました")
                    })
            })
            .catch(error => {
                console.error("解錠時IDトークン取得失敗")
            })
        }
    },[openInfo])

    // オートロックONを押すたびに呼ばれる
    useEffect(()=>{
        if(isFirstRenderAutoOn.current){
            isFirstRenderAutoOn.current = false;
        }
        else{
            if (!window.confirm("オートロックをONにします")){
                return;
            }
            getIdToken()
            .then(result => {
                var token = result;
                const obj = {
                    "command": "auto_lock",
                    "parameter": "enable"
                };
                const method = "PUT";
                const body = JSON.stringify(obj);
                const headers = {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                    'Authorization':token
                    };
                fetch(API_GATEWAY + '/console/v1/devices/modes/' + location.state.lockID,
                {method:method, headers:headers, body:body, mode:"cors"})
                .then((res)=> res.json())
                    .then(data => {
                        console.log("オートロックONのfetch実行完了")
                        // 制御結果取得
                        getControlResults(token, data["control_id"])
                        .then(controlResult => {
                            if(controlResult == "success"){
                                alert("オートロックがONになりました")
                                window.location.reload();
                            }else{
                                console.error("結果取得失敗"+controlResult)
                                alert("オートロック設定に失敗しました")
                            }
                        },[])

                    },[])
                    .catch(err => {
                        console.log("オートロック設定に失敗しました")
                        alert("オートロック設定に失敗しました")
                    })
            })
            .catch(error => {
                console.error("解錠時IDトークン取得失敗")
            })
        }
    },[autoOnInfo])

    // オートロックOFFを押すたびに呼ばれる
    useEffect(()=>{
        if(isFirstRenderAutoOff.current){
            isFirstRenderAutoOff.current = false;
        }
        else{
            if (!window.confirm("オートロックをOFFにします")){
                return;
            }
            getIdToken()
            .then(result => {
                var token = result;
                const obj = {
                    "command": "auto_lock",
                    "parameter": "disable"
                };
                const method = "PUT";
                const body = JSON.stringify(obj);
                const headers = {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                    'Authorization':token
                    };
                fetch(API_GATEWAY + '/console/v1/devices/modes/' + location.state.lockID,
                {method:method, headers:headers, body:body, mode:"cors"})
                .then((res)=> res.json())
                    .then(data => {
                        console.log("オートロックOFFのfetch実行完了")
                        // 制御結果取得
                        getControlResults(token, data["control_id"])
                        .then(controlResult => {
                            if(controlResult == "success"){
                                alert("オートロックがOFFになりました")
                                window.location.reload();
                            }else{
                                console.error("結果取得失敗"+controlResult)
                                alert("オートロック設定に失敗しました")
                            }
                        },[])

                    },[])
                    .catch(err => {
                        console.log("オートロック設定に失敗しました")
                        alert("オートロック設定に失敗しました")
                    })
            })
            .catch(error => {
                console.error("解錠時IDトークン取得失敗")
            })
        }
    },[autoOffInfo])

    // 施錠制御を押すたびに呼ばれる
    useEffect(()=>{
        if(isFirstRenderClose.current){
            isFirstRenderClose.current = false;
        }
        else{
            if (!window.confirm("施錠します")){
                return;
            }
            getIdToken()
            .then(result => {
                const token =result;
                const obj = {
                    "command": "lock",
                    "parameter": "lock"
                };
                const method = "PUT";
                const body = JSON.stringify(obj);
                const headers = {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                    'Authorization':token
                  };
                fetch(API_GATEWAY + '/console/v1/devices/locks/' + location.state.lockID,
                {method:method, headers:headers, body:body, mode:"cors"})
                .then((res)=> res.json())
                    .then(data => {
                        console.log("施錠のfetch実行完了")
                        // 制御結果取得
                        getControlResults(token, data["control_id"])
                        .then(controlResult => {
                            if(controlResult == "success"){
                                alert("施錠に成功しました。")
                                setDebugUpdatelock(debug_updatelock+1)
                            }else{
                                console.error("結果取得失敗"+controlResult)
                                alert("施錠に失敗しました。")
                            }
                        },[])

                    },[])
                    .catch(err => {
                        console.log("施錠のfetch失敗")
                        alert("施錠に失敗しました")
                    })
            })
            .catch(error => {
                console.error("施錠時IDトークン取得失敗")
            })
        }
    },[closeInfo])

    // 登録ボタンを押すたびに呼ばれる
    useEffect(()=>{
        if(isFirstRenderRegist.current){
            isFirstRenderRegist.current = false;
        }
        else{
            var isInvalid = getIsInvalidPlacename();
            if(isInvalid){
                alert(isInvalid)
            }
            else{
                getIdToken()
                .then(result => {
                    console.log("送信する設置場所："+placeName)
                    const obj = {"name": placeName};
                    const method = "PUT";
                    const body = JSON.stringify(obj);
                    const headers = {
                        'Accept': 'application/json',
                        'Content-Type': 'application/json',
                        'Authorization':result
                    };
                    const lockInfoUpdateUrl = API_GATEWAY + "/console/v1/devices/lock-info/"+location.state.lockID
                    fetch(lockInfoUpdateUrl,
                    {method:method, headers:headers, body:body, mode:"cors"})
                    .then(res=> {
                        alert("部屋番号を更新しました")
                        reload();
                    },[])
                    .catch(err => {
                    console.log("fetch失敗")
                    alert("設置部屋番号の登録に失敗しました")
                    })
                }).catch(error => {
                    console.error("登録時IDトークン取得失敗")
                }
                )
            }

        }
    },[registSend])

    // 暗証番号送信を押すたびに呼ばれる
    useEffect(()=>{
        if(isFirstRenderPinSend.current){
            isFirstRenderPinSend.current = false;
        }
        else{
            if (!window.confirm("暗証番号を変更します")){
                return;
            }
            var isInvalid = getIsInvalidPincode();
            if(isInvalid){
                alert(isInvalid)
            }
            else{
                getIdToken()
                .then(result => {
                    var access_groups = document.getElementsByClassName('select_access_group');
                    var select_access_group = []
                    if(access_groups){
                        for (var i = 0; i < access_groups.length; i++){
                            if (access_groups[i].checked){
                                select_access_group.push(Number(access_groups[i].id));
                            }
                        }
                    }
                    console.log("送信する暗証番号："+pinCode)
                    const token = result;
                    const obj = {"user_code": pinCode};
                    if(select_access_group != ""){
                        obj["access_groups"] = select_access_group;
                    }
                    const method = "PUT";
                    const body = JSON.stringify(obj);
                    const headers = {
                        'Accept': 'application/json',
                        'Content-Type': 'application/json',
                        'Authorization':token
                    };
                    fetch(API_GATEWAY + '/console/v1/devices/user-codes/' + location.state.lockID,
                    {method:method, headers:headers, body:body, mode:"cors"})
                    .then((res)=> res.json())
                      .then(data => {
                        console.log("fetch実行完了")
                        // 制御結果取得
                        getControlResults(token, data["control_id"])
                        .then(controlResult => {
                            if(controlResult == "success"){
                                alert("暗証番号変更に成功しました。")
                            }else{
                                console.error("結果取得失敗"+controlResult)
                                alert("暗証番号変更に失敗しました。")
                            }
                        },[])

                      },[])
                      .catch(err => {
                        console.log("fetch失敗")
                        alert("暗証番号登録に失敗しました。")
                        })
                }).catch(error => {
                    console.error("pin送信時IDトークン取得失敗")
                    alert("暗証番号登録に失敗しました。")
                }
                )
            }
        }
    },[pinSend])

    // 暗証番号削除を押すたびに呼ばれる
    useEffect(()=>{
        if(isFirstRenderPinDelete.current){
            isFirstRenderPinDelete.current = false;
        }
        else{
            if (!window.confirm("暗証番号を削除します")){
                return;
            }
            getIdToken()
            .then(result => {
                const token = result;
                const method = "DELETE";
                const headers = {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                    'Authorization':token
                };
                const pinDeleteUrl = API_GATEWAY + "/console/v1/devices/user-codes/" + location.state.lockID;
                fetch(pinDeleteUrl,
                {method:method, headers:headers, mode:"cors"})
                .then((res)=> res.json())
                    .then(data => {
                        console.log("fetch実行完了")
                        // 制御結果取得
                        getControlResults(token, data["control_id"])
                        .then(controlResult => {
                            if(controlResult == "success"){
                                alert("暗証番号削除に成功しました。")
                            }else{
                                console.error("結果取得失敗"+controlResult)
                                alert("暗証番号削除に失敗しました。")
                            }
                        },[])
                    },[])
                    .catch(err => {
                    console.log("fetch失敗")
                    alert("暗証番号の削除に失敗しました")
                    })
            }).catch(error => {
                console.error("pin削除送信時IDトークン取得失敗")
            }
            )
        }
    },[pinDelete])

    // カード番号送信を押すたびに呼ばれる
    useEffect(()=>{
        if(isFirstRenderCardSend.current){
            isFirstRenderCardSend.current = false;
        }
        else{
            if (!window.confirm("カード番号を変更します")){
                return;
            }
            var isInvalid = getIsInvalidCard();
            if(isInvalid){
                alert(isInvalid)
            }
            else{
                getIdToken()
                .then(result => {
                    var access_groups = document.getElementsByClassName('select_card_access_group');
                    var select_access_group = []
                    if(access_groups){
                        for (var i = 0; i < access_groups.length; i++){
                            if (access_groups[i].checked){
                                select_access_group.push(Number(access_groups[i].id));
                            }
                        }
                    }
                    const token = result;
                    const obj = {"card_id": cardCode};
                    if(select_access_group != ""){
                        obj["access_groups"] = select_access_group;
                    }
                    const method = "PUT";
                    const body = JSON.stringify(obj);
                    const headers = {
                        'Accept': 'application/json',
                        'Content-Type': 'application/json',
                        'Authorization':token
                    };
                    fetch(API_GATEWAY + '/console/v1/devices/cards/' + location.state.lockID,
                    {method:method, headers:headers, body:body, mode:"cors"})
                    .then((res)=> res.json())
                        .then(data => {
                        console.log("fetch実行完了")
                        // 制御結果取得
                        getControlResults(token, data["control_id"])
                        .then(controlResult => {
                            if(controlResult == "success"){
                                alert("カード番号変更に成功しました。")
                            }else{
                                console.error("結果取得失敗"+controlResult)
                                alert("カード番号変更に失敗しました。")
                            }
                        },[])

                        },[])
                        .catch(err => {
                        console.log("fetch失敗")
                        alert("カード番号登録に失敗しました。")
                        })
                }).catch(error => {
                    console.error("カード番号送信時IDトークン取得失敗")
                    alert("カード番号登録に失敗しました。")
                }
                )
            }
        }
    },[cardSend])

    // カード番号削除を押すたびに呼ばれる
    useEffect(()=>{
        if(isFirstRenderCardDelete.current){
            isFirstRenderCardDelete.current = false;
        }
        else{
            if (!window.confirm("カード番号を削除します")){
                return;
            }
            getIdToken()
            .then(result => {
                const token = result;
                const method = "DELETE";
                const headers = {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                    'Authorization':token
                };
                const pinDeleteUrl = API_GATEWAY + "/console/v1/devices/cards/" + location.state.lockID;
                fetch(pinDeleteUrl,
                {method:method, headers:headers, mode:"cors"})
                .then((res)=> res.json())
                    .then(data => {
                        console.log("fetch実行完了")
                        // 制御結果取得
                        getControlResults(token, data["control_id"])
                        .then(controlResult => {
                            if(controlResult == "success"){
                                alert("カード番号削除に成功しました。")
                            }else{
                                console.error("結果取得失敗"+controlResult)
                                alert("カード番号削除に失敗しました。")
                            }
                        },[])
                    },[])
                    .catch(err => {
                    console.log("fetch失敗")
                    alert("カード番号の削除に失敗しました")
                    })
            }).catch(error => {
                console.error("カード番号削除送信時IDトークン取得失敗")
            }
            )
        }
    },[cardDelete])
    
    async function isAdmin(){
        try{
            const user = await Auth.currentUserPoolUser();
            const attrs = await Auth.userAttributes(user);
            attrs.forEach(function(attr){
                if (attr.Name == 'custom:authority' &&
                    (attr.Value == 'admin' || attr.Value == 'installation')){
                    setAdmFlag(true);
                }
            });
        }
        catch(e){
            Auth.signOut();
        }
    }
    
    function getIsInvalidPincode(){
        const reg_pin = /[0-9]/;

        if(!pinCode){
            return "暗証番号を入力してください"
        }
        if(!reg_pin.test(pinCode) || pinCode.length < 4 || 8 < pinCode.length){
            return "暗証番号は4～8文字の半角数字にしてください"
        }
    }
    function getIsInvalidCard(){
        const reg_card = /[0-9a-zA-Z]/;

        if(!cardCode){
            return "カード番号を入力してください"
        }
        if(!reg_card.test(cardCode) || cardCode.length < 1 || 32 < cardCode.length){
            return "カード番号は1～32文字の半角英数字にしてください"
        }
    }

    function getIsInvalidPlacename(){
        const reg_emoji = /\u{1F3F4}\u{E0067}\u{E0062}(?:\u{E0077}\u{E006C}\u{E0073}|\u{E0073}\u{E0063}\u{E0074}|\u{E0065}\u{E006E}\u{E0067})\u{E007F}|\u{1F469}\u200D\u{1F469}\u200D(?:\u{1F466}\u200D\u{1F466}|\u{1F467}\u200D[\u{1F466}\u{1F467}])|\u{1F468}(?:\u{1F3FF}\u200D(?:\u{1F91D}\u200D\u{1F468}[\u{1F3FB}-\u{1F3FE}]|[\u{1F33E}\u{1F373}\u{1F37C}\u{1F393}\u{1F3A4}\u{1F3A8}\u{1F3EB}\u{1F3ED}\u{1F4BB}\u{1F4BC}\u{1F527}\u{1F52C}\u{1F680}\u{1F692}\u{1F9AF}-\u{1F9B3}\u{1F9BC}\u{1F9BD}])|\u{1F3FE}\u200D(?:\u{1F91D}\u200D\u{1F468}[\u{1F3FB}-\u{1F3FD}\u{1F3FF}]|[\u{1F33E}\u{1F373}\u{1F37C}\u{1F393}\u{1F3A4}\u{1F3A8}\u{1F3EB}\u{1F3ED}\u{1F4BB}\u{1F4BC}\u{1F527}\u{1F52C}\u{1F680}\u{1F692}\u{1F9AF}-\u{1F9B3}\u{1F9BC}\u{1F9BD}])|\u{1F3FD}\u200D(?:\u{1F91D}\u200D\u{1F468}[\u{1F3FB}\u{1F3FC}\u{1F3FE}\u{1F3FF}]|[\u{1F33E}\u{1F373}\u{1F37C}\u{1F393}\u{1F3A4}\u{1F3A8}\u{1F3EB}\u{1F3ED}\u{1F4BB}\u{1F4BC}\u{1F527}\u{1F52C}\u{1F680}\u{1F692}\u{1F9AF}-\u{1F9B3}\u{1F9BC}\u{1F9BD}])|\u{1F3FC}\u200D(?:\u{1F91D}\u200D\u{1F468}[\u{1F3FB}\u{1F3FD}-\u{1F3FF}]|[\u{1F33E}\u{1F373}\u{1F37C}\u{1F393}\u{1F3A4}\u{1F3A8}\u{1F3EB}\u{1F3ED}\u{1F4BB}\u{1F4BC}\u{1F527}\u{1F52C}\u{1F680}\u{1F692}\u{1F9AF}-\u{1F9B3}\u{1F9BC}\u{1F9BD}])|\u{1F3FB}\u200D(?:\u{1F91D}\u200D\u{1F468}[\u{1F3FC}-\u{1F3FF}]|[\u{1F33E}\u{1F373}\u{1F37C}\u{1F393}\u{1F3A4}\u{1F3A8}\u{1F3EB}\u{1F3ED}\u{1F4BB}\u{1F4BC}\u{1F527}\u{1F52C}\u{1F680}\u{1F692}\u{1F9AF}-\u{1F9B3}\u{1F9BC}\u{1F9BD}])|\u200D(?:\u2764\uFE0F\u200D(?:\u{1F48B}\u200D)?\u{1F468}|[\u{1F468}\u{1F469}]\u200D(?:\u{1F466}\u200D\u{1F466}|\u{1F467}\u200D[\u{1F466}\u{1F467}])|\u{1F466}\u200D\u{1F466}|\u{1F467}\u200D[\u{1F466}\u{1F467}]|[\u{1F468}\u{1F469}]\u200D[\u{1F466}\u{1F467}]|[\u2695\u2696\u2708]\uFE0F|[\u{1F466}\u{1F467}]|[\u{1F33E}\u{1F373}\u{1F37C}\u{1F393}\u{1F3A4}\u{1F3A8}\u{1F3EB}\u{1F3ED}\u{1F4BB}\u{1F4BC}\u{1F527}\u{1F52C}\u{1F680}\u{1F692}\u{1F9AF}-\u{1F9B3}\u{1F9BC}\u{1F9BD}])|(?:\u{1F3FF}\u200D[\u2695\u2696\u2708]|\u{1F3FE}\u200D[\u2695\u2696\u2708]|\u{1F3FD}\u200D[\u2695\u2696\u2708]|\u{1F3FC}\u200D[\u2695\u2696\u2708]|\u{1F3FB}\u200D[\u2695\u2696\u2708])\uFE0F|\u{1F3FF}|\u{1F3FE}|\u{1F3FD}|\u{1F3FC}|\u{1F3FB})?|\u{1F9D1}(?:[\u{1F3FB}-\u{1F3FF}]\u200D(?:\u{1F91D}\u200D\u{1F9D1}[\u{1F3FB}-\u{1F3FF}]|[\u{1F33E}\u{1F373}\u{1F37C}\u{1F384}\u{1F393}\u{1F3A4}\u{1F3A8}\u{1F3EB}\u{1F3ED}\u{1F4BB}\u{1F4BC}\u{1F527}\u{1F52C}\u{1F680}\u{1F692}\u{1F9AF}-\u{1F9B3}\u{1F9BC}\u{1F9BD}])|\u200D(?:\u{1F91D}\u200D\u{1F9D1}|[\u{1F33E}\u{1F373}\u{1F37C}\u{1F384}\u{1F393}\u{1F3A4}\u{1F3A8}\u{1F3EB}\u{1F3ED}\u{1F4BB}\u{1F4BC}\u{1F527}\u{1F52C}\u{1F680}\u{1F692}\u{1F9AF}-\u{1F9B3}\u{1F9BC}\u{1F9BD}]))|\u{1F469}(?:\u200D(?:\u2764\uFE0F\u200D(?:\u{1F48B}\u200D[\u{1F468}\u{1F469}]|[\u{1F468}\u{1F469}])|[\u{1F33E}\u{1F373}\u{1F37C}\u{1F393}\u{1F3A4}\u{1F3A8}\u{1F3EB}\u{1F3ED}\u{1F4BB}\u{1F4BC}\u{1F527}\u{1F52C}\u{1F680}\u{1F692}\u{1F9AF}-\u{1F9B3}\u{1F9BC}\u{1F9BD}])|\u{1F3FF}\u200D[\u{1F33E}\u{1F373}\u{1F37C}\u{1F393}\u{1F3A4}\u{1F3A8}\u{1F3EB}\u{1F3ED}\u{1F4BB}\u{1F4BC}\u{1F527}\u{1F52C}\u{1F680}\u{1F692}\u{1F9AF}-\u{1F9B3}\u{1F9BC}\u{1F9BD}]|\u{1F3FE}\u200D[\u{1F33E}\u{1F373}\u{1F37C}\u{1F393}\u{1F3A4}\u{1F3A8}\u{1F3EB}\u{1F3ED}\u{1F4BB}\u{1F4BC}\u{1F527}\u{1F52C}\u{1F680}\u{1F692}\u{1F9AF}-\u{1F9B3}\u{1F9BC}\u{1F9BD}]|\u{1F3FD}\u200D[\u{1F33E}\u{1F373}\u{1F37C}\u{1F393}\u{1F3A4}\u{1F3A8}\u{1F3EB}\u{1F3ED}\u{1F4BB}\u{1F4BC}\u{1F527}\u{1F52C}\u{1F680}\u{1F692}\u{1F9AF}-\u{1F9B3}\u{1F9BC}\u{1F9BD}]|\u{1F3FC}\u200D[\u{1F33E}\u{1F373}\u{1F37C}\u{1F393}\u{1F3A4}\u{1F3A8}\u{1F3EB}\u{1F3ED}\u{1F4BB}\u{1F4BC}\u{1F527}\u{1F52C}\u{1F680}\u{1F692}\u{1F9AF}-\u{1F9B3}\u{1F9BC}\u{1F9BD}]|\u{1F3FB}\u200D[\u{1F33E}\u{1F373}\u{1F37C}\u{1F393}\u{1F3A4}\u{1F3A8}\u{1F3EB}\u{1F3ED}\u{1F4BB}\u{1F4BC}\u{1F527}\u{1F52C}\u{1F680}\u{1F692}\u{1F9AF}-\u{1F9B3}\u{1F9BC}\u{1F9BD}])|\u{1F469}\u{1F3FF}\u200D\u{1F91D}\u200D[\u{1F468}\u{1F469}][\u{1F3FB}-\u{1F3FE}]|\u{1F469}\u{1F3FE}\u200D\u{1F91D}\u200D[\u{1F468}\u{1F469}][\u{1F3FB}-\u{1F3FD}\u{1F3FF}]|\u{1F469}\u{1F3FD}\u200D\u{1F91D}\u200D[\u{1F468}\u{1F469}][\u{1F3FB}\u{1F3FC}\u{1F3FE}\u{1F3FF}]|\u{1F469}\u{1F3FC}\u200D\u{1F91D}\u200D[\u{1F468}\u{1F469}][\u{1F3FB}\u{1F3FD}-\u{1F3FF}]|\u{1F469}\u{1F3FB}\u200D\u{1F91D}\u200D[\u{1F468}\u{1F469}][\u{1F3FC}-\u{1F3FF}]|\u{1F469}\u200D\u{1F466}\u200D\u{1F466}|\u{1F469}\u200D\u{1F469}\u200D[\u{1F466}\u{1F467}]|(?:\u{1F441}\uFE0F\u200D\u{1F5E8}|\u{1F469}(?:\u{1F3FF}\u200D[\u2695\u2696\u2708]|\u{1F3FE}\u200D[\u2695\u2696\u2708]|\u{1F3FD}\u200D[\u2695\u2696\u2708]|\u{1F3FC}\u200D[\u2695\u2696\u2708]|\u{1F3FB}\u200D[\u2695\u2696\u2708]|\u200D[\u2695\u2696\u2708])|\u{1F3F3}\uFE0F\u200D\u26A7|\u{1F9D1}(?:[\u{1F3FB}-\u{1F3FF}]\u200D[\u2695\u2696\u2708]|\u200D[\u2695\u2696\u2708])|\u{1F43B}\u200D\u2744|(?:[\u{1F3C3}\u{1F3C4}\u{1F3CA}\u{1F46E}\u{1F470}\u{1F471}\u{1F473}\u{1F477}\u{1F481}\u{1F482}\u{1F486}\u{1F487}\u{1F645}-\u{1F647}\u{1F64B}\u{1F64D}\u{1F64E}\u{1F6A3}\u{1F6B4}-\u{1F6B6}\u{1F926}\u{1F935}\u{1F937}-\u{1F939}\u{1F93D}\u{1F93E}\u{1F9B8}\u{1F9B9}\u{1F9CD}-\u{1F9CF}\u{1F9D6}-\u{1F9DD}][\u{1F3FB}-\u{1F3FF}]|[\u{1F46F}\u{1F93C}\u{1F9DE}\u{1F9DF}])\u200D[\u2640\u2642]|[\u26F9\u{1F3CB}\u{1F3CC}\u{1F575}][\uFE0F\u{1F3FB}-\u{1F3FF}]\u200D[\u2640\u2642]|\u{1F3F4}\u200D\u2620|[\u{1F3C3}\u{1F3C4}\u{1F3CA}\u{1F46E}\u{1F470}\u{1F471}\u{1F473}\u{1F477}\u{1F481}\u{1F482}\u{1F486}\u{1F487}\u{1F645}-\u{1F647}\u{1F64B}\u{1F64D}\u{1F64E}\u{1F6A3}\u{1F6B4}-\u{1F6B6}\u{1F926}\u{1F935}\u{1F937}-\u{1F939}\u{1F93D}\u{1F93E}\u{1F9B8}\u{1F9B9}\u{1F9CD}-\u{1F9CF}\u{1F9D6}-\u{1F9DD}]\u200D[\u2640\u2642]|[\xA9\xAE\u203C\u2049\u2122\u2139\u2194-\u2199\u21A9\u21AA\u2328\u23CF\u23ED-\u23EF\u23F1\u23F2\u23F8-\u23FA\u24C2\u25AA\u25AB\u25B6\u25C0\u25FB\u25FC\u2600-\u2604\u260E\u2611\u2618\u2620\u2622\u2623\u2626\u262A\u262E\u262F\u2638-\u263A\u2640\u2642\u265F\u2660\u2663\u2665\u2666\u2668\u267B\u267E\u2692\u2694-\u2697\u2699\u269B\u269C\u26A0\u26A7\u26B0\u26B1\u26C8\u26CF\u26D1\u26D3\u26E9\u26F0\u26F1\u26F4\u26F7\u26F8\u2702\u2708\u2709\u270F\u2712\u2714\u2716\u271D\u2721\u2733\u2734\u2744\u2747\u2763\u2764\u27A1\u2934\u2935\u2B05-\u2B07\u3030\u303D\u3297\u3299\u{1F170}\u{1F171}\u{1F17E}\u{1F17F}\u{1F202}\u{1F237}\u{1F321}\u{1F324}-\u{1F32C}\u{1F336}\u{1F37D}\u{1F396}\u{1F397}\u{1F399}-\u{1F39B}\u{1F39E}\u{1F39F}\u{1F3CD}\u{1F3CE}\u{1F3D4}-\u{1F3DF}\u{1F3F5}\u{1F3F7}\u{1F43F}\u{1F4FD}\u{1F549}\u{1F54A}\u{1F56F}\u{1F570}\u{1F573}\u{1F576}-\u{1F579}\u{1F587}\u{1F58A}-\u{1F58D}\u{1F5A5}\u{1F5A8}\u{1F5B1}\u{1F5B2}\u{1F5BC}\u{1F5C2}-\u{1F5C4}\u{1F5D1}-\u{1F5D3}\u{1F5DC}-\u{1F5DE}\u{1F5E1}\u{1F5E3}\u{1F5E8}\u{1F5EF}\u{1F5F3}\u{1F5FA}\u{1F6CB}\u{1F6CD}-\u{1F6CF}\u{1F6E0}-\u{1F6E5}\u{1F6E9}\u{1F6F0}\u{1F6F3}])\uFE0F|\u{1F469}\u200D\u{1F467}\u200D[\u{1F466}\u{1F467}]|\u{1F3F3}\uFE0F\u200D\u{1F308}|\u{1F469}\u200D\u{1F467}|\u{1F469}\u200D\u{1F466}|\u{1F415}\u200D\u{1F9BA}|\u{1F469}(?:\u{1F3FF}|\u{1F3FE}|\u{1F3FD}|\u{1F3FC}|\u{1F3FB})?|\u{1F1FD}\u{1F1F0}|\u{1F1F6}\u{1F1E6}|\u{1F1F4}\u{1F1F2}|\u{1F408}\u200D\u2B1B|\u{1F441}\uFE0F|\u{1F3F3}\uFE0F|\u{1F9D1}[\u{1F3FB}-\u{1F3FF}]?|\u{1F1FF}[\u{1F1E6}\u{1F1F2}\u{1F1FC}]|\u{1F1FE}[\u{1F1EA}\u{1F1F9}]|\u{1F1FC}[\u{1F1EB}\u{1F1F8}]|\u{1F1FB}[\u{1F1E6}\u{1F1E8}\u{1F1EA}\u{1F1EC}\u{1F1EE}\u{1F1F3}\u{1F1FA}]|\u{1F1FA}[\u{1F1E6}\u{1F1EC}\u{1F1F2}\u{1F1F3}\u{1F1F8}\u{1F1FE}\u{1F1FF}]|\u{1F1F9}[\u{1F1E6}\u{1F1E8}\u{1F1E9}\u{1F1EB}-\u{1F1ED}\u{1F1EF}-\u{1F1F4}\u{1F1F7}\u{1F1F9}\u{1F1FB}\u{1F1FC}\u{1F1FF}]|\u{1F1F8}[\u{1F1E6}-\u{1F1EA}\u{1F1EC}-\u{1F1F4}\u{1F1F7}-\u{1F1F9}\u{1F1FB}\u{1F1FD}-\u{1F1FF}]|\u{1F1F7}[\u{1F1EA}\u{1F1F4}\u{1F1F8}\u{1F1FA}\u{1F1FC}]|\u{1F1F5}[\u{1F1E6}\u{1F1EA}-\u{1F1ED}\u{1F1F0}-\u{1F1F3}\u{1F1F7}-\u{1F1F9}\u{1F1FC}\u{1F1FE}]|\u{1F1F3}[\u{1F1E6}\u{1F1E8}\u{1F1EA}-\u{1F1EC}\u{1F1EE}\u{1F1F1}\u{1F1F4}\u{1F1F5}\u{1F1F7}\u{1F1FA}\u{1F1FF}]|\u{1F1F2}[\u{1F1E6}\u{1F1E8}-\u{1F1ED}\u{1F1F0}-\u{1F1FF}]|\u{1F1F1}[\u{1F1E6}-\u{1F1E8}\u{1F1EE}\u{1F1F0}\u{1F1F7}-\u{1F1FB}\u{1F1FE}]|\u{1F1F0}[\u{1F1EA}\u{1F1EC}-\u{1F1EE}\u{1F1F2}\u{1F1F3}\u{1F1F5}\u{1F1F7}\u{1F1FC}\u{1F1FE}\u{1F1FF}]|\u{1F1EF}[\u{1F1EA}\u{1F1F2}\u{1F1F4}\u{1F1F5}]|\u{1F1EE}[\u{1F1E8}-\u{1F1EA}\u{1F1F1}-\u{1F1F4}\u{1F1F6}-\u{1F1F9}]|\u{1F1ED}[\u{1F1F0}\u{1F1F2}\u{1F1F3}\u{1F1F7}\u{1F1F9}\u{1F1FA}]|\u{1F1EC}[\u{1F1E6}\u{1F1E7}\u{1F1E9}-\u{1F1EE}\u{1F1F1}-\u{1F1F3}\u{1F1F5}-\u{1F1FA}\u{1F1FC}\u{1F1FE}]|\u{1F1EB}[\u{1F1EE}-\u{1F1F0}\u{1F1F2}\u{1F1F4}\u{1F1F7}]|\u{1F1EA}[\u{1F1E6}\u{1F1E8}\u{1F1EA}\u{1F1EC}\u{1F1ED}\u{1F1F7}-\u{1F1FA}]|\u{1F1E9}[\u{1F1EA}\u{1F1EC}\u{1F1EF}\u{1F1F0}\u{1F1F2}\u{1F1F4}\u{1F1FF}]|\u{1F1E8}[\u{1F1E6}\u{1F1E8}\u{1F1E9}\u{1F1EB}-\u{1F1EE}\u{1F1F0}-\u{1F1F5}\u{1F1F7}\u{1F1FA}-\u{1F1FF}]|\u{1F1E7}[\u{1F1E6}\u{1F1E7}\u{1F1E9}-\u{1F1EF}\u{1F1F1}-\u{1F1F4}\u{1F1F6}-\u{1F1F9}\u{1F1FB}\u{1F1FC}\u{1F1FE}\u{1F1FF}]|\u{1F1E6}[\u{1F1E8}-\u{1F1EC}\u{1F1EE}\u{1F1F1}\u{1F1F2}\u{1F1F4}\u{1F1F6}-\u{1F1FA}\u{1F1FC}\u{1F1FD}\u{1F1FF}]|[#\*0-9]\uFE0F\u20E3|[\u{1F3C3}\u{1F3C4}\u{1F3CA}\u{1F46E}\u{1F470}\u{1F471}\u{1F473}\u{1F477}\u{1F481}\u{1F482}\u{1F486}\u{1F487}\u{1F645}-\u{1F647}\u{1F64B}\u{1F64D}\u{1F64E}\u{1F6A3}\u{1F6B4}-\u{1F6B6}\u{1F926}\u{1F935}\u{1F937}-\u{1F939}\u{1F93D}\u{1F93E}\u{1F9B8}\u{1F9B9}\u{1F9CD}-\u{1F9CF}\u{1F9D6}-\u{1F9DD}][\u{1F3FB}-\u{1F3FF}]|[\u26F9\u{1F3CB}\u{1F3CC}\u{1F575}][\uFE0F\u{1F3FB}-\u{1F3FF}]|\u{1F3F4}|[\u270A\u270B\u{1F385}\u{1F3C2}\u{1F3C7}\u{1F442}\u{1F443}\u{1F446}-\u{1F450}\u{1F466}\u{1F467}\u{1F46B}-\u{1F46D}\u{1F472}\u{1F474}-\u{1F476}\u{1F478}\u{1F47C}\u{1F483}\u{1F485}\u{1F4AA}\u{1F57A}\u{1F595}\u{1F596}\u{1F64C}\u{1F64F}\u{1F6C0}\u{1F6CC}\u{1F90C}\u{1F90F}\u{1F918}-\u{1F91C}\u{1F91E}\u{1F91F}\u{1F930}-\u{1F934}\u{1F936}\u{1F977}\u{1F9B5}\u{1F9B6}\u{1F9BB}\u{1F9D2}-\u{1F9D5}][\u{1F3FB}-\u{1F3FF}]|[\u261D\u270C\u270D\u{1F574}\u{1F590}][\uFE0F\u{1F3FB}-\u{1F3FF}]|[\u270A\u270B\u{1F385}\u{1F3C2}\u{1F3C7}\u{1F408}\u{1F415}\u{1F43B}\u{1F442}\u{1F443}\u{1F446}-\u{1F450}\u{1F466}\u{1F467}\u{1F46B}-\u{1F46D}\u{1F472}\u{1F474}-\u{1F476}\u{1F478}\u{1F47C}\u{1F483}\u{1F485}\u{1F4AA}\u{1F57A}\u{1F595}\u{1F596}\u{1F64C}\u{1F64F}\u{1F6C0}\u{1F6CC}\u{1F90C}\u{1F90F}\u{1F918}-\u{1F91C}\u{1F91E}\u{1F91F}\u{1F930}-\u{1F934}\u{1F936}\u{1F977}\u{1F9B5}\u{1F9B6}\u{1F9BB}\u{1F9D2}-\u{1F9D5}]|[\u{1F3C3}\u{1F3C4}\u{1F3CA}\u{1F46E}\u{1F470}\u{1F471}\u{1F473}\u{1F477}\u{1F481}\u{1F482}\u{1F486}\u{1F487}\u{1F645}-\u{1F647}\u{1F64B}\u{1F64D}\u{1F64E}\u{1F6A3}\u{1F6B4}-\u{1F6B6}\u{1F926}\u{1F935}\u{1F937}-\u{1F939}\u{1F93D}\u{1F93E}\u{1F9B8}\u{1F9B9}\u{1F9CD}-\u{1F9CF}\u{1F9D6}-\u{1F9DD}]|[\u{1F46F}\u{1F93C}\u{1F9DE}\u{1F9DF}]|[\u231A\u231B\u23E9-\u23EC\u23F0\u23F3\u25FD\u25FE\u2614\u2615\u2648-\u2653\u267F\u2693\u26A1\u26AA\u26AB\u26BD\u26BE\u26C4\u26C5\u26CE\u26D4\u26EA\u26F2\u26F3\u26F5\u26FA\u26FD\u2705\u2728\u274C\u274E\u2753-\u2755\u2757\u2795-\u2797\u27B0\u27BF\u2B1B\u2B1C\u2B50\u2B55\u{1F004}\u{1F0CF}\u{1F18E}\u{1F191}-\u{1F19A}\u{1F201}\u{1F21A}\u{1F22F}\u{1F232}-\u{1F236}\u{1F238}-\u{1F23A}\u{1F250}\u{1F251}\u{1F300}-\u{1F320}\u{1F32D}-\u{1F335}\u{1F337}-\u{1F37C}\u{1F37E}-\u{1F384}\u{1F386}-\u{1F393}\u{1F3A0}-\u{1F3C1}\u{1F3C5}\u{1F3C6}\u{1F3C8}\u{1F3C9}\u{1F3CF}-\u{1F3D3}\u{1F3E0}-\u{1F3F0}\u{1F3F8}-\u{1F407}\u{1F409}-\u{1F414}\u{1F416}-\u{1F43A}\u{1F43C}-\u{1F43E}\u{1F440}\u{1F444}\u{1F445}\u{1F451}-\u{1F465}\u{1F46A}\u{1F479}-\u{1F47B}\u{1F47D}-\u{1F480}\u{1F484}\u{1F488}-\u{1F4A9}\u{1F4AB}-\u{1F4FC}\u{1F4FF}-\u{1F53D}\u{1F54B}-\u{1F54E}\u{1F550}-\u{1F567}\u{1F5A4}\u{1F5FB}-\u{1F644}\u{1F648}-\u{1F64A}\u{1F680}-\u{1F6A2}\u{1F6A4}-\u{1F6B3}\u{1F6B7}-\u{1F6BF}\u{1F6C1}-\u{1F6C5}\u{1F6D0}-\u{1F6D2}\u{1F6D5}-\u{1F6D7}\u{1F6EB}\u{1F6EC}\u{1F6F4}-\u{1F6FC}\u{1F7E0}-\u{1F7EB}\u{1F90D}\u{1F90E}\u{1F910}-\u{1F917}\u{1F91D}\u{1F920}-\u{1F925}\u{1F927}-\u{1F92F}\u{1F93A}\u{1F93F}-\u{1F945}\u{1F947}-\u{1F976}\u{1F978}\u{1F97A}-\u{1F9B4}\u{1F9B7}\u{1F9BA}\u{1F9BC}-\u{1F9CB}\u{1F9D0}\u{1F9E0}-\u{1F9FF}\u{1FA70}-\u{1FA74}\u{1FA78}-\u{1FA7A}\u{1FA80}-\u{1FA86}\u{1FA90}-\u{1FAA8}\u{1FAB0}-\u{1FAB6}\u{1FAC0}-\u{1FAC2}\u{1FAD0}-\u{1FAD6}]/gu;

        if(!placeName){
            return "設置部屋番号を入力してください"
        }
        if(reg_emoji.test(placeName)){
            return "設置部屋番号に絵文字が含まれています"
        }
        if(32 < placeName.length){
            return "設置部屋番号は最大32文字です"
        }
    }

    function reload(){
        window.location.reload();
    }

    if (loading){
        return (

        <div class="center_parents">
            <table class="overall_table">
                <tr>
                    <td>
                    <div class="title_text">ドアロック設定　＜{hotelName}＞</div>
                    </td>
                </tr>
            </table>

            <hr color="#00B4C6" size="6" />
            <br />
            <table class="table_border overall_table">
                <tr>
                    <td>
                        <div>
                        <img src={loadimg}/>
                        </div>
                    </td>
                </tr>
            </table>
        </div>
        );
    }
    return(
            <div>

                <div class="title_text">ドアロック設定　＜{hotelName}＞</div>
                <hr color="#00B4C6" size="6" />
                <br />
                <div class="title_text">状態</div>  
                    <table class="table_border">
                        <tr>
                            <td class="td_width_settingdoorlock_title"></td>
                            <td></td>
                            <td style={{width:"140px"}}></td>
                            <td></td>
                        </tr>
                        <tr class="tr_height_settingdoorlock">
                            <td class="table_border_updown_thtd_left" style={{width:"180px"}}>
                                <label class="li_left">Serial Number</label>
                            </td>
                            <td colspan="3" class="table_border_updown_thtd_right">
                                　{serialNumber}
                            </td>
                        </tr>
                        <tr class="tr_height_settingdoorlock">
                            <td class="table_border_updown_thtd_left">
                                <label class="li_left">接続ゲートウェイ</label>
                            </td>
                            <td colspan="3" class="table_border_updown_thtd_right">
                                　{connectionGW}
                            </td>
                        </tr>
                        <tr class="tr_height_settingdoorlock">
                            <td class="table_border_updown_thtd_left">
                                <label class="li_left">フロア</label>
                            </td>
                            <td colspan="3" class="table_border_updown_thtd_right">
                                　{floor}
                            </td>
                        </tr>
                        <tr class="tr_height_settingdoorlock">
                            <td class="table_border_updown_thtd_left">
                                <label class="">部屋番号</label>
                            </td>
                            <td colspan="3" class="table_border_updown_thtd_right">
                                　{oldPlaceName}
                            </td>
                        </tr>
                        <tr class="tr_height_settingdoorlock">
                            <td class="table_border_updown_thtd_left">
                                <label class="li_left">異常通知</label>
                            </td>
                            <td class="table_border_updown_thtd_right">
                                　{error}
                            </td>
                            <td class="table_border_updown_thtd_right">
                            異常発生日時：
                            </td>
                            <td class="table_border_updown_thtd_right">
                            <div class="li_left">　{errorTime}</div>
                            </td>
                        </tr>
                        <tr class="tr_height_settingdoorlock">
                            <td class="table_border_updown_thtd_left">
                                <label class="li_left">電池残量</label>
                            </td>
                            <td class="table_border_updown_thtd_right">
                                　{battery}
                            </td>
                            <td class="table_border_updown_thtd_right">
                                <button class="button" onClick={() => setDebugUpdatebattery(debug_updatebattery+1)}>更新</button>
                            </td>
                            <td class="table_border_updown_thtd_right">
                                <div class="doorlock_table_updown_center">　{batteryTime}</div>
                            </td>
                        </tr>
                        <tr class="tr_height_settingdoorlock">
                            <td class="table_border_updown_thtd_left">
                                <label class="li_left">施錠状態</label>
                            </td>
                            <td>
                                　{lockStatus}
                            </td>
                            <td class="table_border_updown_thtd_right">
                                <button class="button" onClick={() => setDebugUpdatelock(debug_updatelock+1)}>更新</button>
                            </td>
                            <td class="table_border_updown_thtd_right">
                                <div class="doorlock_table_updown_center ">　{lockStatusTime}</div>
                            </td>
                        </tr>
                        <tr class="tr_height_settingdoorlock">
                            <td class="table_border_updown_thtd_left">
                                <label class="li_left">ドア状態</label>
                            </td>
                            <td class="table_border_updown_thtd_right">
                                　{doorStatus}
                            </td>
                            <td class="table_border_updown_thtd_right">
                                <button class="button" onClick={() => setDebugUpdatelock(debug_updatelock+1)}>更新</button>
                            </td>
                            <td class="table_border_updown_thtd_right">
                                <div class="doorlock_table_updown_center ">　{doorStatusTime}</div>
                            </td>
                        </tr>
                        <tr class="tr_height_settingdoorlock">
                            <td class="table_border_updown_thtd_left">
                                <label class="li_left">RSSI（電波強度）</label>
                            </td>
                            <td class="table_border_updown_thtd_right">
                                　{rssi}
                            </td>
                            <td class="table_border_updown_thtd_right">
                                <button class="button" onClick={() => setDebugUpdaterssi(debug_updaterssi+1)}>更新</button>
                            </td>
                            <td class="table_border_updown_thtd_right">
                                <div class="doorlock_table_updown_center ">　{rssiTime}</div>
                            </td>
                        </tr>
                        <tr class="tr_height_settingdoorlock">
                            <td class="table_border_updown_thtd_left">
                                <label class="li_left">オートロック</label>
                            </td>
                            <td class="table_border_updown_thtd_right">
                                　{autoLockStatus}
                            </td>
                            <td class="table_border_updown_thtd_right">
                                <button class="button" onClick={() => reload()}>更新</button>
                            </td>
                            <td class="table_border_updown_thtd_right">
                                <div class="doorlock_table_updown_center ">　{autoLockStatusTime}</div>
                            </td>
                        </tr>
                    </table>
                    <br />

                    
                    <div class="title_text">登録/制御</div>
                    <table class="table_border">
                        <tr>
                            <td class="td_width_settingdoorlock_title"></td>
                            <td class="td_width_settingdoorlock_textbox"></td>
                            <td></td>
                        </tr>
                        <tr>
                            <td class="table_border_updown_thtd_left" style={{width:"180px"}}>
                                <label class="">部屋番号</label>
                            </td>
                            <td class="table_border_updown_thtd_right" style={{width:"270px"}}>
                                <input class="textbox" style={{width:"300px"}} type="text" value={placeName} onChange={registHandleChange} maxLength={32}/>
                            </td>
                            
                            <td class="table_border_updown_thtd_right" colspan="2">
                                {admFlag &&
                                <button class="button" onClick={() => setRegistSend(registSend+1)}>登録</button>}
                            </td>
                        </tr>
                        <tr>
                            <td class="table_border_updown_thtd_left">
                                <label class="li_left">施錠制御</label>
                            </td>
                            <td colspan="2" class="table_border_updown_thtd_right">
                                <button class="button" onClick={() => setCloseInfo(closeInfo+1)}>施錠</button>
                                <button class="button" onClick={() => setOpenInfo(openInfo+1)}>解錠</button>
                            </td>
                        </tr>
                        <tr>
                            <td class="table_border_updown_thtd_left">
                                <label class="li_left">暗証番号</label>
                            </td>
                            <td class="table_border_up_thtd_right">
                                <input class="textbox li_left" style={{width:"300px"}} type="text" value={pinCode} onChange={pinCodeHandleChange}/>
                            </td>
                            <td class="table_border_up_thtd_right">
                                <button class="button " onClick={() => setPinSend(pinSend+1)}>送信</button>
                                <button class="button " onClick={() => setPinDelete(pinDelete+1)}>削除</button>
                            </td>
                            <td class="table_border_up_thtd_right">
                            </td>
                        </tr>
                        {accessGroupLink}
                        <tr>
                            <td class="table_border_updown_thtd_left">
                                <label class="li_left">カード番号</label>
                            </td>
                            <td class="table_border_up_thtd_right">
                                <input class="textbox li_left" style={{width:"300px"}} type="text" value={cardCode} onChange={cardCodeHandleChange}/>
                            </td>
                            <td class="table_border_up_thtd_right">
                                <button class="button " onClick={() => setCardSend(cardSend+1)}>送信</button>
                                <button class="button " onClick={() => setCardDelete(cardDelete+1)}>削除</button>
                            </td>
                            <td class="table_border_up_thtd_right">
                            </td>
                        </tr>
                        {accessGroupLink_card}
                        <tr>
                            <td class="table_border_updown_thtd_left">
                                <label class="li_left">オートロック</label>
                            </td>
                            <td colspan="3" class="table_border_updown_thtd_right">
                                <button class="button" onClick={() => setAutoOnInfo(closeInfo+1)}>ON</button>
                                <button class="button" onClick={() => setAutoOffInfo(openInfo+1)}>OFF</button>
                            </td>
                        </tr>
                    </table>
                    <br />
            </div>
        
    )
}
 
export default Setting_doorlock;
